export { default } from './Paginate.js';